class PoorJudgementPurchase extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    const data = this.querySelector('[data-purchase-data]');
    if (!data) return;
    this.data = JSON.parse(data.textContent);
    if (!this.data.variants.length) return;
    this.initialized = true;
    this.form = this.querySelector('form');
    this.button = this.querySelector('[data-add-button]');
    this.message = this.querySelector('[data-purchase-message]');
    this.primaryContainer = this.querySelector('[data-primary-options]');
    this.express = this.querySelector('[data-express-checkout]');
    this.styleImages = JSON.parse(document.getElementById('style-data')?.textContent || '[]');
    this.total = this.querySelector('[data-purchase-total]');
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: this.data.currency, currencyDisplay: 'code'
    });
    this.initial = this.data.variants.find(v => v.id === this.data.selected) || this.data.variants[0];
    this.rows = [];
    this.count = 1;
    this.petInclude = this.querySelector('[data-pet-include]');
    this.petVariant = this.querySelector('[data-pet-variant]');
    this.petInclude?.addEventListener('change', () => {
      this.petVariant.disabled = !this.petInclude.checked;
      this.update();
    });
    this.petVariant?.addEventListener('change', () => this.update());
    this.querySelector('.purchase-fallback').hidden = true;
    this.querySelector('.purchase-enhanced').hidden = false;
    this.querySelectorAll('[data-bundle-count]').forEach(input => input.addEventListener('change', () => {
      this.count = Number(input.value);
      this.renderRows();
    }));
    this.form.addEventListener('submit', event => this.addToCart(event));
    this.addEventListener('choose-style', event => {
      const normalize = value => String(value).toLowerCase().replace(/[’']/g, "'");
      this.rows[0]?.forEach(select => {
        const match = Array.from(select.options).find(option => normalize(option.value) === normalize(event.detail));
        if (match) select.value = match.value;
      });
      this.update();
    });
    this.renderRows();
  }

  normalize(value) { return String(value).toLowerCase().replace(/[’']/g, "'"); }

  styleImage(value) {
    return this.styleImages.find(style => this.normalize(style.name) === this.normalize(value))?.image;
  }

  renderRows() {
    const saved = this.rows.map(row => row.map(select => select.value));
    this.primaryContainer.replaceChildren();
    this.querySelectorAll('[data-bundle-slot]').forEach(slot => {
      slot.replaceChildren();
      slot.hidden = Number(slot.dataset.bundleSlot) !== this.count || this.count === 1;
    });
    this.rows = [];
    this.primaryControls = [];
    for (let index = 0; index < this.count; index++) {
      const fieldset = document.createElement('fieldset');
      fieldset.className = index === 0 ? 'pj-primary-row' : 'pj-compact-row';
      if (index > 0) {
        const legend = document.createElement('legend');
        legend.textContent = `Sweater ${index + 1}`;
        fieldset.append(legend);
        const image = document.createElement('img');
        image.alt = ''; image.dataset.rowImage = String(index);
        fieldset.append(image);
      }
      const selections = this.data.options.map((option, optionIndex) => {
        const values = option.values.map(value => typeof value === 'object' ? value.name : value);
        const isStyle = option.name.toLowerCase() === 'style';
        const select = document.createElement('select');
        values.forEach(value => {
          const item = document.createElement('option');
          item.value = value; item.textContent = value; select.append(item);
        });
        select.value = saved[index]?.[optionIndex] ?? this.initial.options[optionIndex];
        select.addEventListener('change', () => this.update());
        if (index === 0) {
          const group = document.createElement('fieldset');
          group.className = 'pj-primary-row';
          const legend = document.createElement('legend');
          const selected = document.createElement('span');
          selected.className = 'pj-choice-value';
          legend.append(document.createTextNode(`${option.name} — `), selected);
          const choices = document.createElement('div');
          choices.className = isStyle ? 'pj-style-choices' : 'pj-size-choices';
          const orderedValues = isStyle ? values.slice().sort((a,b) => this.styleImages.findIndex(x=>this.normalize(x.name)===this.normalize(a))-this.styleImages.findIndex(x=>this.normalize(x.name)===this.normalize(b))) : values;
          const buttons = orderedValues.map(value => {
            const button = document.createElement('button');
            button.type = 'button'; button.dataset.choice = value;
            button.className = isStyle ? 'pj-style-choice' : 'pj-size-choice';
            button.setAttribute('aria-label', `${option.name}: ${value}`);
            if (isStyle && this.styleImage(value)) {
              const image = document.createElement('img');
              image.src = this.styleImage(value); image.alt = ''; button.append(image);
              button.title = value;
            } else button.textContent = value;
            button.addEventListener('click', () => { select.value = value; this.update(); });
            choices.append(button); return button;
          });
          select.hidden = true;
          group.append(legend, choices, select); fieldset.append(group);
          this.primaryControls.push({select, selected, buttons, optionIndex});
        } else {
          const label = document.createElement('label');
          label.className = 'option-title'; label.append(document.createTextNode(option.name), select);
          fieldset.append(label);
        }
        return select;
      });
      this.rows.push(selections);
      if (index === 0) this.primaryContainer.append(fieldset);
      else this.querySelector(`[data-bundle-slot="${this.count}"]`).append(fieldset);
    }
    this.update();
  }

  selectedVariants() {
    return this.rows.map(row => this.data.variants.find(variant =>
      variant.options.every((option, index) => option === row[index].value)
    ));
  }

  update() {
    const variants = this.selectedVariants();
    this.primaryControls.forEach(({select, selected, buttons, optionIndex}) => {
      selected.textContent = select.value;
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.choice === select.value));
        button.disabled = !this.data.variants.some(variant => variant.available && variant.price > 0 && variant.options.every((value,i) => value === (i === optionIndex ? button.dataset.choice : this.rows[0][i].value)));
      });
    });
    this.querySelectorAll('[data-row-image]').forEach(image => {
      const row = this.rows[Number(image.dataset.rowImage)];
      const styleIndex = this.data.options.findIndex(option => option.name.toLowerCase() === 'style');
      image.src = this.styleImage(row[styleIndex]?.value) || variants[Number(image.dataset.rowImage)]?.image || '';
    });
    if (this.express) this.express.hidden = this.count !== 1 || Boolean(this.petInclude?.checked);
    const pet = this.petInclude?.checked ? this.petVariant?.selectedOptions[0] : null;
    const unavailable = variants.some(variant => !variant || !variant.available || variant.price <= 0) ||
      Boolean(this.petInclude?.checked && (!pet || pet.disabled || Number(pet.dataset.price) <= 0));
    this.ready = !unavailable;
    this.button.disabled = unavailable || this.busy;
    const subtotal = variants.reduce((sum, variant) => sum + (variant?.price || 0), 0);
    const petPrice = pet ? Number(pet.dataset.price) : 0;
    // Keep these rates aligned with the automatic Shopify sweater discounts.
    const rate = this.count >= 3 ? 20 : this.count === 2 ? 10 : 0;
    // Shopify rounds each item's percentage discount down to a whole cent.
    const savings = variants.reduce((sum, variant) => sum + Math.floor((variant?.price || 0) * rate / 100), 0);
    this.total.textContent = unavailable ? 'This combination is unavailable.' :
      `Your total: ${this.money.format((subtotal - savings + petPrice) / 100)}${pet ? " · includes pet outfit" : ""}`;
    if (!unavailable && savings > 0) {
      const note = document.createElement('small');
      note.textContent = `You save ${this.money.format(savings / 100)} on sweaters · applied automatically in your bag`;
      this.total.append(note);
    }
    this.message.textContent = '';
    if (variants[0]) this.form.elements.id.value = variants[0].id;
    const photo = document.getElementById('product-photo');
    const firstStyleIndex = this.data.options.findIndex(option => option.name.toLowerCase() === 'style');
    const styleName = variants[0]?.options[firstStyleIndex];
    const nextImage = this.styleImage(styleName) || variants[0]?.image;
    if (photo && nextImage) { photo.src = nextImage; photo.alt = variants[0].options.join(' / '); }
    document.querySelectorAll('.thumb[data-style]').forEach(button => {
      const imageStyle = this.styleImages[Number(button.dataset.style)];
      button.setAttribute('aria-pressed', String(this.normalize(imageStyle?.name) === this.normalize(styleName)));
    });
  }

  async addToCart(event) {
    event.preventDefault();
    if (!this.ready || this.busy) return;
    this.busy = true;
    this.button.disabled = true;
    this.button.textContent = 'ADDING…';
    this.message.textContent = '';
    const quantities = new Map();
    this.selectedVariants().forEach(variant => quantities.set(variant.id, (quantities.get(variant.id) || 0) + 1));
    if (this.petInclude?.checked) quantities.set(Number(this.petVariant.value), 1);
    try {
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: Array.from(quantities, ([id, quantity]) => ({id, quantity}))})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'These items could not be added. Please review your bag.');
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.message.textContent = error.message || 'We could not confirm that the items were added. Please review your bag before trying again.';
      const link = document.createElement('a');
      link.href = this.dataset.cartUrl;
      link.textContent = ' View your bag';
      this.message.append(link);
      this.busy = false;
      this.button.disabled = !this.ready;
      this.button.textContent = 'ADD TO BAG →';
    }
  }
}
if (!customElements.get('pj-purchase')) customElements.define('pj-purchase', PoorJudgementPurchase);
